/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_Reason_In_From_PxkInputs */

const vi_sl_new_reason_in_from_pxk = /** @type {(inputs: Sl_New_Reason_In_From_PxkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ phiếu cân chè khô`)
};

/**

* @param {Sl_New_Reason_In_From_PxkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_reason_in_from_pxk = /** @type {((inputs?: Sl_New_Reason_In_From_PxkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Reason_In_From_PxkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_reason_in_from_pxk(inputs)
});